import React, { useEffect }  from "react"
import styled from 'styled-components'
import { Link, useStaticQuery, graphql } from 'gatsby'
import SmallArrow from '../../svgs/small-arrow.svg'
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import Slider from "react-slick"


const Offerings = () => {

    useEffect(() => {

        if (typeof window !== `undefined`) {
            gsap.registerPlugin(ScrollTrigger)
            gsap.core.globals('ScrollTrigger', ScrollTrigger)
        }

        ScrollTrigger.matchMedia({

            "(min-width: 1200px)": function() {

                // Our Work Entrance
                let tlEcTwo = gsap.timeline({
                    paused: true,
                    scrollTrigger: {
                        trigger: "#our_work_animate",
                        start: 'top 80%',
                        end: 'top 80%',
                        id: 'our_work_animate',
                        toggleActions: "play play reverse reverse",
                        },
                    })
                tlEcTwo.to('.our-work-title-bar', { duration: 1, left: '0' }, 0)
                tlEcTwo.to('.ow-title-h2', { duration: 1, right: '0' }, 0.4)
            }

        });
    
    }, []);

    return(
        <MainSection id="our_work_animate">
            <div class="our-work-title-bar">
                <div class="ow-title-box">
                    <div className="ow-title-h2">
                        <h2>Workshops</h2>
                    </div>
                    <div  className="content">
                        <Link to="/predictive-media-training">Predictive Media</Link>
                    </div>
                    <div className="content">
                        <Link to="/persuasive-presentations">Persuasive Presentations</Link>
                    </div>
                    <div className="content">
                        <Link to="/breaking-bad-news-crisis-simulator">Crisis Simulator</Link>
                    </div>
                    <div className="content">
                        <Link to="/rapid-response-planning-workshop">Rapid Response Planning</Link>
                    </div>
                    <div className="content">
                        <Link to="/brand-messaging-workshop">Brand Messaging</Link>
                    </div>
                </div>
            </div>
        </MainSection>
    );

}

const MainSection = styled.section`
    width: 100%;
    overflow: hidden;
    margin-bottom: 80px;
    margin-top: 0px;
    .our-work-title-bar {
        width: 100%;
        margin-bottom: 10px;
        position: relative;
        left: -150%;
        &:before {
            content: '';
            position: absolute;
            height: calc(100% - 0px);
            width: 200%;
            top: 0px;
            left: calc(-200% + 20px);
            background-color: #C44C4A;
        }
        .ow-title-box {
            width: 100%;
            height: 100px;
            position: relative;
            background-color: #C44C4A;
            display: flex;
            justify-content: space-evenly;
        }
        h2 {
            font-family: "Work Sans";
            font-size: 34px;
            font-weight: 700;
            color: #fff;
            text-transform: uppercase;
            height: auto;
        }
        .ow-title-h2{
            height: 100px;
            display: flex;
            align-items: center;
            width: 280px;
            margin-left: 80px;
            margin-top: -10px;
        }
        .content{
            height: 100px;
            display: flex;
            align-items: center;
            width: 180px;
            text-align: center;
            a {
                font-family: "Work Sans";
                font-size: 20px;
                font-weight: 700;
                padding: 0px 0px;
                color: #fff;
                text-transform: uppercase;
                text-decoration: none;
            }
        }
    }
    .slick-list{
        height: 150px;
    }
    .slick-slide{
        height: 150px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    @media(max-width: 1200px) {
        .our-work-title-bar {
            left: auto !important;
            .ow-title-box {
                &:before {
                    background-size: 20%;
                }
            }
            h2 {
                right: 150px !important;
            }
        }
        .our-work-slider {
            top: 0 !important;
            opacity: 1 !important;
        }
    }
    @media(max-width: 1080px) {
        .our-work-title-bar {
            display: none;
        }
    }
`

export default Offerings